import React from "react";
import DataGrid, { IColumnProps } from "devextreme-react/data-grid";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import { ContentBlock, StdGrid, StdToolbar, createGridOptions, setColumnDataSource, stdReadOnlyGridOptions } from "../../components";
import { fillingTargetStore, organizationService } from "../../api";
import AuthorizedComponent from "../authorized-component";
import { enums } from "../../base";
import { FillingTargetModel, OrganizationModel } from "../../models";

interface FillingTargetState {
    orgs: OrganizationModel[];
    columns: IColumnProps[];
}

export default class FillingTargetPage extends AuthorizedComponent<any, FillingTargetState> {
    objectName = "FillingTarget";
    moduleName = "FillingTarget";
    gridRef = React.createRef<DataGrid>();
    toolbarRef = React.createRef<StdToolbar>();
    gridOptions = createGridOptions("fillingTargets", this.gridRef, stdReadOnlyGridOptions);

    constructor(props: Readonly<any>) {
        super(props);

        this.state = {
            orgs: [],
            columns: [
                { dataField: 'code' },
                {
                    dataField: 'organizationId',
                    lookup: { dataSource: [], displayExpr: 'name', valueExpr: 'id' }
                }
            ]
        };

        this.gridOptions.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptions.onRowDblClick = e => this.onButtonClick(e.data, "edit");
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.loadOrgs();
    }

    async loadOrgs() {
        const data = await organizationService.searchAll();
        setColumnDataSource(this.state.columns, "organizationId", data);
        this.setState({ orgs: data });
    }

    onSelectionChanged(e: SelectionChangedEvent) {
        if (e.selectedRowsData.length === 1) {
            this.toolbarRef.current?.setModel(e.selectedRowsData[0]);
        } else {
            this.toolbarRef.current?.setModel({});
        }
    }

    onButtonClick(model: FillingTargetModel, name: string) {
        const grid = this.gridRef.current?.instance;

        if (grid) {
            switch (name) {
                case "add":
                    if (this.permissions[enums.stdActions.create]) {
                        grid.addRow();
                    }
                    break;

                case "edit":
                    if (this.permissions[enums.stdActions.update]) {
                        grid.editRow(grid.getRowIndexByKey(model.code));
                    }
                    break;

                case "delete":
                    if (this.permissions[enums.stdActions.delete]) {
                        grid.deleteRow(grid.getRowIndexByKey(model.code));
                    }
                    break;
            }
        }
    }

    render() {
        return (
            <ContentBlock caption={"充装去向"}>
                <StdToolbar
                    permissions={this.permissions}
                    ref={this.toolbarRef}
                    onButtonClick={this.onButtonClick} />
                <StdGrid
                    moduleName={this.moduleName}
                    gridRef={this.gridRef}
                    dataSource={fillingTargetStore}
                    options={this.gridOptions}
                    columns={this.state.columns}
                    popupWidth={400}
                    popupHeight={250}
                    formColCount={1} />
            </ContentBlock>
        );
    }
}